import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const getUser = createAsyncThunk('User/getUser', async () => {
  let response = await fetch('/bizcareui/api/auth/user');
  let json = await response.json();
  //console.log('json', json);
  return json;

  //det som returneras här, kommer att bli vår action.payload
});
const initialState = {
  user: '',
  login: '',
  isAuthenticated: false,
};
const UserSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    LogoutUserState: () => initialState,
  },
  extraReducers: {
    [getUser.fulfilled]: (state, action) => {
      if (action.payload.message === 'User not authenticated') {
        state.user = '';
        state.isAuthenticated = false;
      } else {
        state.user = action.payload;
        state.isAuthenticated = true;
      }
    },
    [getUser.pending]: (state) => {
      state.user = '';
      state.isAuthenticated = false;
    },
    [getUser.rejected]: (state) => {
      // state.status = 'Failed to fetch data...';
      state.user = '';
      state.isAuthenticated = false;
    },
  },
});

export const { LogoutUserState } = UserSlice.actions;
export default UserSlice.reducer;
// const { createSlice } = require('@reduxjs/toolkit');

// const initialState = {
//   isAuthenticated: false,
//   user: {},
//   isloading: true,
// };
// const UserSlice = createSlice({
//   name: 'USERINFO',
//   initialState,
//   reducers: {
//     getUserInfo: (state, action) => {
//       state.user = action.payload;
//     },
//     getisAuthenticated: (state, action) => {
//       state.isAuthenticated = action.payload;
//     },
//     getisloading: (state, action) => {
//       state.isloading = action.payload;
//     },

//     resetState: () => initialState,
//   },
// });
// export const { getUserInfo, getisAuthenticated, getisloading } =
//   UserSlice.actions;
// export default UserSlice.reducer;
